import { redirect } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import { userStore } from "../../store/user";
import { VendorInsightsPage } from "./VendorInsightsPage";

// Ronin-internal: cross-vendor sales analysis over the reporting view.
const vendorInsightsAuthGate = async () => {
  const user = userStore.getState().user;
  if (!user) return redirect("/login");
  if (user.role_id !== 1) return redirect("/");
  return null;
};

export const vendorInsightsRouter = {
  path: "/vendor-insights",
  id: "vendor-insights",
  element: <VendorInsightsPage />,
  loader: requireAuth(undefined, vendorInsightsAuthGate),
  handle: {
    crumb: () => <Breadcrumb name="Vendor Insights" href="/vendor-insights" />,
  },
};
